import {Link} from 'react-router-dom';

const SubPage = () => {
    return (
        <div>
            <p>두번째 페이지입니다</p>
        </div>
    )
};

export default SubPage;